import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { IconEmma } from 'design-system/icons/IconEmma';
import { IconClose } from 'design-system/icons/IconClose';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { ToastModal } from 'design-system/ToastModal';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const TransactionEditToast = ({ isVisible, onClose }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<ToastModal isVisible={isVisible} position="bottom" style={styles.modal} onCloseAction={onClose}>
      <IconEmma color={colors.elements.white} style={styles.iconEmma} width={rem(32)} height={rem(32)}/>
      <View style={styles.toastTextContainer}>
        <Text TextThin-14 White>
          We learn from your edits. Keep editing to make Emma smarter.
        </Text>
      </View>
      <TouchableBounce style={styles.closeIcon} onPress={onClose}>
        <IconClose color={colors.elements.white}/>
      </TouchableBounce>
    </ToastModal>);
};
const styleSet = createStyleSheets(() => ({
    modal: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: rem(40),
    },
    iconEmma: {
        marginRight: rem(12),
    },
    closeIcon: {
        marginLeft: rem(12),
        alignSelf: 'flex-start',
    },
    toastTextContainer: {
        flex: 1,
    },
}));
export default TransactionEditToast;
